@use '../styles/tokens' as *;

$gutter: 15px;

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: $blue-gray-9;
}

.fullPageLoading {
  position: relative;
  flex: 1;
}

.main {
  position: relative;
  width: 100%;
  max-width: $content-max;
  margin: 0 auto;
  padding-top: 20px;

  @include lg {
    padding: 30px 60px;
  }
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: $gutter;
  padding: 0;
  border: none;
  background: none;
  @include text-13;
  font-weight: 700;
  color: $black;
  text-decoration: none;

  @include lg {
    margin-left: 0;
  }
}

.backIcon {
  width: 18px;
  height: 18px;
}

.layout {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;

  @include lg {
    flex-direction: row;
    align-items: flex-start;
    gap: 30px;
  }
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 $gutter;

  @include lg {
    flex: 1;
    gap: 30px;
    padding: 0;
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 $gutter $gutter;
  background-color: white;

  @include lg {
    width: 420px;
    flex-shrink: 0;
    padding: 0;
    background: none;
  }
}

// ----- Product card -----
.card {
  padding: 15px;
  background: $white;
  border-radius: $radius-card;
  box-shadow: 0 21px 45px 0 rgba(0, 0, 0, 0.04);

  @include lg {
    padding: 45px;
  }
}

.skeletonCard {
  @include lg {
    min-width: 688px;
  }
}

.skeleton {
  background: $blue-gray-8;
  border-radius: 6px;
  filter: blur(2px);
  animation: skeletonPulse 1.2s ease-in-out infinite;
}
.skeletonLogo {
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: 8px;

  @include lg {
    width: 64px;
    height: 64px;
  }
}
.skeletonEyebrow {
  width: 90px;
  height: 11px;
}
.skeletonTitle {
  width: 70%;
  height: 22px;
  margin-top: 10px;
}
.skeletonLabel {
  width: 120px;
  height: 13px;
  margin-top: 24px;
}
.skeletonLine {
  width: 100%;
  height: 12px;
}
.skeletonField {
  width: 120px;
  height: 40px;
}
.skeletonPrice {
  width: 90px;
  height: 24px;
}

@keyframes skeletonPulse {
  50% {
    opacity: 0.5;
  }
}

.cardHead {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
.logo {
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: 8px;

  @include lg {
    width: 64px;
    height: 64px;
  }
}
.intro {
  min-width: 0;
}
.eyebrow {
  @include text-11;
  font-weight: 500;
  color: $black;
}
.title {
  @include text-heading-4;
}

.includesTitle {
  margin: 24px 0 0;
  @include text-13;
  font-weight: 500;
  color: $black;
}
.benefits {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px 32px;
  margin-top: 8px;

  @include lg {
    grid-template-columns: 1fr 1fr;
  }
}
.benefitCol {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.divider {
  height: 1px;
  margin: 20px 0;
  background: $blue-gray-8;

  @include lg {
    margin: 30px 0;
  }
}

.selectionTitle {
  @include text-13;
  font-weight: 500;
  color: $black;
}
.selectionRow {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 15px;
  margin-top: 8px;
}
.selectionPrice {
  margin-left: auto;
  text-align: right;
}

// ----- Upgrade banner -----
.upgrade {
  position: relative;
  padding: 30px;
  background: $enscape-light;
  border-radius: $radius-card;
  margin-top: 15px;

  @include lg {
    margin: 60px -30px -30px;
  }
}

.upgradeGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @include lg {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }
}
.upgradeEyebrow {
  @include text-13;
  font-weight: 500;
  color: $black;
}
.upgradeTitle {
  @include text-heading-4;
  color: $enscape;
}
.upgradeLogos {
  display: flex;
  gap: 6px;
  margin-top: 16px;
}
.upgradeLogo {
  width: 24px;
  height: 24px;
  border-radius: 5px;
  object-fit: contain;
}
.upgradeIncludesTitle {
  @include text-13;
  font-weight: 500;
  color: $black;
}
.upgradeList {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.upgradeBtn {
  margin-top: 16px;
  padding: 10px 28px;
  border: 1px solid $black;
  border-radius: 999px;
  background: none;
  @include text-13;
  font-weight: 700;
  color: $black;
}

// ----- Order summary -----
.summaryPromo {
  margin-top: 25px;
}
.summaryTotals {
  margin-top: 15px;
}
.checkoutBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  margin-top: 8px;
  border: none;
  border-radius: 999px;
  background: $utility-blue;
  @include text-13;
  font-weight: 700;
  color: $white;

  &:disabled {
    background-color: $base-6;
    border-color: $base-6;
    cursor: auto;
  }
}
.checkoutIcon {
  width: 20px;
  height: 20px;
}
